/* global angular */

/**
* gc.localstorage Module
* LocalStorage works pretty well on every browser, except Sarafi when it is in
* private browsing mode. Setting a cookie could be a workaround, but Safari disallows
* thrid domain cookies so it wouldn't work in an iframe.
*
* The solution here is to save in a standard JS variable (localStorageReplacement).
* It will not be kept if the page changes, but at least it will allow the user to
* log in and write a comment...
*/
angular
.module('gc.postmessage', [])

.service('PostMessageService', ['Utils', function(Utils) {
  'use strict';

  this.postMessage = function(name, data) {
    var pid = Utils.getParameterByName('pid') || 0;
    window.parent.postMessage({ name, data, pid }, '*');
  };

  this.postCommand = function(command, data) {
    window.parent.postMessage({
      type: "__semiologic__COMMAND__semiologic__",
      command,
      data
    }, '*');
  };

}]);
